import React, { useState, useEffect } from "react";
import OrderForm from "../Forms/OrderForm";
import { clearCart } from "../../actions/newCartActions";
import CartItem from "./cartItem";
import { useSelector, useDispatch } from "react-redux";

export default function ConfirmedOrder(props) {
  const [totalPrice, setTotalPrice] = useState(0);

  const cart = useSelector((state) => state.newCartReducer);
  const teacherInfo = useSelector((state) => state.teacherInformationReducer);

  const dispatch = useDispatch();

  useEffect(() => {
    setTotalPrice(0);
    cart.result.forEach((order) => {
      setTotalPrice(
        (prevstate) =>
          prevstate + order.priceStudent * order.addedStudents.length
      );
    });
  }, [cart.result]);

  const cleanCartAfterPurchase = () => {
    dispatch(clearCart());
  };

  const cartList = () => {
    return cart.result.map((cartItem, i) => {
      if (cartItem.addedStudents.length > 0) {
        return (
          <CartItem
            key={i}
            readonly={true}
            cartItem={cartItem}
            onAddUnit={null}
            onDeductUnit={null}
            handleDeleteFromCart={null}
          />
        );
      } else {
        return null;
      }
    });
  };

  return (
    <>
      <OrderForm
        {...props}
        cartList={cartList}
        cart={cart}
        totalPrice={totalPrice}
        teacherInformation={teacherInfo}
        cleanCartAfterPurchase={() => cleanCartAfterPurchase()}
      />
    </>
  );
}
